import { useTranslation } from "react-i18next"
import Avatar from "components/commons/Avatar"
import PaginationBar from "components/widget/PaginationBar"
import secondsToHms from "../../../../utility/SecondToHms"
import Modal from "components/commons/Modal"
import NoData from "components/commons/NoData"


function AbsenceRequestsTable({
    title,
    icon = "fa-solid fa-file-arrow-up",
    items = [],
    isLoadingContent = false,
    availableActions = [],
    onRequestAccepted,
    onRequestDenied,
    onRequestCanceled,
    onRequestDeleted,
    onPageChange,
    currentPage,
    itemsPerPage,
    totalItems
}) {

    const [t, i18n] = useTranslation(["global", "absenceReport"])

    function sortByDate(a, b) {
        return b.createdDate - a.createdDate
    }

    const orderedItems = [...items]

    orderedItems.sort(sortByDate)

    let uiItems = items.map((absenceReports, i) => {


        const statusColor = () => {
            switch (absenceReports.status) {
                case "ACCEPTED": return "bg-success"
                case "DENIED": return "bg-danger"
                case "PENDING": return "bg-warning"
                case "CANCELED": return "bg-secondary"
                default: return ""
            }
        }

        const statusLabel = () => {
            switch (absenceReports.status) {
                case "ACCEPTED": return t("absenceReport:entity.absence.status.accepted")
                case "DENIED": return t("absenceReport:entity.absence.status.denied")
                case "PENDING": return t("absenceReport:entity.absence.status.pending")
                case "CANCELED": return t("absenceReport:entity.absence.status.canceled")
                case "DELETED": return t("absenceReport:entity.absence.status.deleted")
                default: return ""
            }
        }

        const absenceTypeIcon = () => {
            switch (absenceReports.type) {
                case "HOLIDAY": return <i className="fa-solid fa-umbrella-beach"></i>
                case "SICK": return <i className="fa-solid fa-house-chimney-medical"></i>
                case "PERMIT": return <i className="fa-solid fa-clock"></i>
                default: return
            }
        }

        const absenceTypeLabel = () => {
            switch (absenceReports.type) {
                case "HOLIDAY": return t("absenceReport:entity.absence.reason.holidays")
                case "SICK": return t("absenceReport:entity.absence.reason.sick")
                case "PERMIT": return t("absenceReport:entity.absence.reason.permitt")
                default: return t("absenceReport:entity.absence.reason.other")
            }
        }

        return (
            <section key={absenceReports.guid}>
                <hr />
                <div className="row">

                    <div className="col-sm">

                        <h2>{absenceTypeIcon()}</h2> <div>
                            <h5> {absenceTypeLabel().toUpperCase()}</h5>

                            <span className={`badge rounded-pill ${statusColor()}`}>

                                {statusLabel().toUpperCase()}
                            </span>
                        </div>


                    </div>
                    <div className="col-sm">
                        {
                            absenceReports.type == "PERMIT" ?
                                <p>
                                    {new Date(absenceReports.startDate * 1000).toLocaleDateString()}<br />
                                    {new Date(absenceReports.startDate * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - {new Date(absenceReports.endDate * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}<br />
                                    <b>{secondsToHms(absenceReports.endDate - absenceReports.startDate)}</b>

                                </p> :
                                <p>
                                    <b>{t("particles.from")} </b>{new Date(absenceReports.startDate * 1000).toLocaleDateString()}<br />
                                    <b>{t("particles.to")} </b> {new Date(absenceReports.endDate * 1000).toLocaleDateString()}
                                </p>

                        }

                    </div>
                    {absenceReports.userDisplayName &&
                        <div className="col-sm">
                            <Avatar displayName={absenceReports.userDisplayName} guid={absenceReports.user_guid} />
                        </div>
                    }


                    <div className={`col-sm ${absenceReports.note ? '' : ''}`}>

                        {absenceReports.note ?
                            <section>
                                <i className="fa-solid fa-circle-info"></i><br />
                                <p className="bg-dark p-2">
                                    {absenceReports.note}
                                </p>
                            </section> : ""}
                    </div>
                    <div className="col-sm">
                        {

                            new Date(absenceReports.createdDate).toLocaleDateString()

                        }<br />
                        {new Date(absenceReports.createdDate).toLocaleTimeString()}

                    </div>
                    <div className="col-sm">
                        {(absenceReports.status == 'PENDING') &&
                            <section>
                                {
                                    availableActions.includes(KEY_ABSENCEREQUEST_ACTION_ACCEPT) &&
                                    <Modal
                                        modalId={KEY_ABSENCEREQUEST_ACTION_ACCEPT + i}
                                        buttonClass="btn-success"
                                        buttonIcon={<i className="fa-solid fa-check fa-beat-fade"></i>}
                                        buttonLabel={t("action.accept")}
                                        iconOnly={true}
                                        body={t("absenceReport:helper.confirm_accept")}
                                        onConfirm={() => { onRequestAccepted(absenceReports.guid) }}
                                    />
                                }
                                &nbsp;
                                {
                                    availableActions.includes(KEY_ABSENCEREQUEST_ACTION_DENY) &&
                                    <Modal
                                        modalId={KEY_ABSENCEREQUEST_ACTION_DENY + i}
                                        buttonClass="btn-danger"
                                        buttonIcon={<i className="fa-solid fa-xmark fa-beat-fade"></i>}
                                        buttonLabel={t("action.deny")}
                                        iconOnly={true}
                                        body={t("absenceReport:helper.confirm_deny")}
                                        onConfirm={() => { onRequestDenied(absenceReports.guid) }}
                                    />
                                }
                                &nbsp;{
                                    availableActions.includes(KEY_ABSENCEREQUEST_ACTION_CANCEL_MY) &&
                                    <Modal
                                        modalId={KEY_ABSENCEREQUEST_ACTION_CANCEL_MY + i}
                                        buttonClass="btn-secondary"
                                        buttonIcon={<i className="fa-solid fa-xmark"></i>}
                                        buttonLabel={t("action.cancel")}
                                        iconOnly={true}
                                        body={t("absenceReport:helper.confirm_cancel")}
                                        onConfirm={() => { onRequestCanceled(absenceReports.guid) }}
                                    />
                                }

                            </section>
                        }
                        {
                            (absenceReports.status != 'PENDING') && (absenceReports.status != 'CANCELED') && (absenceReports.status != 'DELETED') &&
                            availableActions.includes(KEY_ABSENCEREQUEST_ACTION_DELETE) &&

                            <Modal
                                modalId={KEY_ABSENCEREQUEST_ACTION_DELETE + i}
                                buttonClass="btn-secondary"
                                buttonIcon={<i className="fa-regular fa-trash-can"></i>}
                                buttonLabel={t("action.delete")}
                                confirmStyle="btn-danger"
                                iconOnly={true}
                                body={t("absenceReport:helper.confirm_delete")}
                                onConfirm={() => { onRequestDeleted(absenceReports.guid) }}
                            />
                        }



                    </div>
                </div>
            </section>
        );
    })

    let content = (

        <div className={`card bg-black bg-opacity-10 text-white mb-4 ${isLoadingContent ? "opacity-25" : ""}`} id="absence-request">
            <div className="card-header">
                <i className={`${icon}`}></i> {title ? title : t("absenceReport:menu.requests")}
            </div>

            <div className="card-body text-center">

                {
                    orderedItems.length == 0 ?

                        <NoData message={t("absenceReport:no_data.no_requests")} />
                        :
                        <>
                            <div className="row opacity-50">
                                <div className="col-sm">

                                </div>
                                <div className="col-sm">
                                    {t("property.period")}
                                </div>
                                {
                                    orderedItems.length > 0 && orderedItems[0].userDisplayName &&
                                    <div className="col-sm">
                                        {t("entity.employee")}
                                    </div>
                                }

                                <div className="col-sm">
                                    {t("property.notes")}
                                </div>
                                <div className="col-sm">
                                    {t("property.submited")}
                                </div>
                                <div className="col-sm">
                                    {t("property.actions")}
                                </div>
                                <br />
                            </div>
                            {uiItems}
                        </>


                }




            </div>

            <PaginationBar
                currentPage={currentPage}
                postsPerPage={itemsPerPage}
                totalPosts={totalItems}
                paginate={(e) => {
                    console.log(e)
                    onPageChange(e)
                }}
            />

        </div>

    )

    return content

}

export default AbsenceRequestsTable

export const KEY_ABSENCEREQUEST_ACTION_ACCEPT = "ACCEPT"
export const KEY_ABSENCEREQUEST_ACTION_DENY = "DENY"
export const KEY_ABSENCEREQUEST_ACTION_DELETE = "CANCEL"
export const KEY_ABSENCEREQUEST_ACTION_CANCEL_MY = "CANCEL_MY"